import { render } from "./ProductAutocomplete.vue?vue&type=template&id=511a4727"
import script from "./ProductAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProductAutocomplete.vue?vue&type=script&lang=js"
script.render = render

export default script